import { defineMessage } from 'services/localization';

export const messages = {
    totalExpenses: defineMessage('total_expenses'),
    advance: defineMessage('advance_to_apply'),
    reimbursableAmount: defineMessage('total_reimbursable_amount'),
};
